import { NgClass } from "@angular/common";
import { Component } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "@ponder-core/auth/auth.service";
import { EventBroker } from "@ponder-core/events/eventBroker";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { OverauthorizedComponent } from "@ponder-shared/components/overauthorized.component";
import { distinctUntilChanged } from "rxjs";

@Component({
    imports: [ReactiveFormsModule, BusySpinComponent, NgClass, OverauthorizedComponent],
    templateUrl: "./login-recovery.component.html"
})
export class LoginRecoveryComponent {
    public recoveryForm!: FormGroup;
    public isProcessing: boolean = false;
    public processingError?: string;

    public emailError?: string;

    public constructor(formBuilder: FormBuilder, private events: EventBroker, private authService: AuthService, private router: Router) {
        this.recoveryForm = formBuilder.group({
            email: ["", [Validators.required, Validators.email]]
        });
        
        this.recoveryForm.get("email")!.valueChanges
            .pipe(distinctUntilChanged())
            .subscribe(() => {
                this.emailError = (this.recoveryForm.get("email")!.valid ? undefined : this.emailError);
                this.processingError = undefined;
            });
    }

    public ngOnDestroy(): void {
        this.events.ui.restoreContentPaddingEvent.emit();
    }

    public ngOnInit(): void {
        this.events.ui.hideNavbarEvent.emit();
        this.events.ui.removeContentPaddingEvent.emit();
    }

    public onEmailLoseFocus(): void {
        this.emailError = undefined;
        var emailElement = this.recoveryForm.get("email")!;

        if (!emailElement.valid)
        {
            if ((emailElement.value as string).length == 0)
            {
                this.emailError = "Email address is required.";
            }
            else
            {
                this.emailError = "Invalid email address.";
            }
        }
    }

    public canSubmit(): boolean {
        return this.recoveryForm.valid && !this.isProcessing && !this.processingError;
    }

    public async onSubmit() {
        if (!this.canSubmit()) {
            return;
        }

        this.isProcessing = true;
        this.processingError = undefined;
        this.recoveryForm.disable({ emitEvent: false });

        var email = this.recoveryForm.get("email")?.value;

        if (email) {
            await this.authService.sendPasswordRecoveryEmailAsync(email);
        }

        this.router.navigate(["/login/recovery/confirmation"]);
    }
}